import React, { useEffect, useState } from "react";
import { getDocFiles, getPaperDownloadUrl } from "../../../api/papers";
import { File, Download, Image, Settings } from "lucide-react";
import FolderPermissionDialog from "./FolderPermissionDialog";

/**
 * FileList
 * - 특정 문서(Docs.dns)에 연결된 첨부파일 목록을 표시
 *
 * Props:
 *  - dns: string          // 문서 고유번호
 *  - showTitle?: boolean  // 기본 true
 *  - compact?: boolean    // true면 작은 리스트 스타일
 */
export default function FileList({
  dns,
  showTitle = true,
  compact = false,
  onFilesLoaded,
}) {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [permDialogOpen, setPermDialogOpen] = useState(false);
  const [targetFile, setTargetFile] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    try {
      const stored = localStorage.getItem("user");
      if (stored) {
        setCurrentUser(JSON.parse(stored));
      }
    } catch (e) {
      console.error("사용자 정보 로드 실패:", e);
    }
  }, []);

  useEffect(() => {
    if (!dns) return;
    setLoading(true);
    getDocFiles(dns)
      .then((res) => {
        const fileList = res.data || [];
        setFiles(fileList);
        if (onFilesLoaded) onFilesLoaded(fileList); // 콜백 호출
      })
      .catch((err) => console.error("파일 목록 조회 실패:", err))
      .finally(() => setLoading(false));
  }, [dns]);
  console.log(dns, "@@");

  if (!dns) return null;

  return (
    <div className="space-y-2 text-sm">
      {showTitle && (
        <h4 className="font-medium text-slate-700 mb-1 flex items-center gap-2">
          <File className="w-3.5 h-3.5 text-slate-500" />
          첨부파일
          <span className="text-xs text-slate-400 ml-0.5">
            ({files.length})
          </span>
        </h4>
      )}

      {loading ? (
        <p className="text-slate-400 text-xs">불러오는 중...</p>
      ) : files.length === 0 ? (
        <p className="text-slate-400 text-xs">첨부된 파일이 없습니다.</p>
      ) : (
        <>
          <ul className="divide-y divide-slate-100 border border-slate-200 rounded-lg bg-white overflow-hidden">
            {files.map((f) => (
              <li
                key={f.id}
                className="flex items-center justify-between px-3 py-1.5 hover:bg-slate-50 transition-colors"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="flex items-center gap-1.5 truncate">
                  {f.name.match(/\.(png|jpg|jpeg|gif)$/i) ? (
                    <Image className="w-3.5 h-3.5 text-slate-400 shrink-0" />
                  ) : (
                    <File className="w-3.5 h-3.5 text-slate-400 shrink-0" />
                  )}
                  <span className="truncate text-slate-700">{f.name}</span>
                </div>
                <div className="flex items-center gap-3">
                  <a
                    href={getPaperDownloadUrl(f.id)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-1 text-slate-500 hover:text-indigo-600 text-xs"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Download className="w-3.5 h-3.5" />
                    다운로드
                  </a>
                  <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                    {f.can_manage && (
                      <button
                        onClick={() => {
                          setTargetFile(f);
                          setPermDialogOpen(true);
                        }}
                        className="p-1 hover:bg-slate-100 rounded text-slate-400 hover:text-indigo-600 transition-colors"
                        title="권한 설정"
                      >
                        <Settings className="w-4 h-4" />
                      </button>
                    )}
                  </div>
                </div>
              </li>
            ))}
          </ul>
          {targetFile && (
            <FolderPermissionDialog
              open={permDialogOpen}
              onOpenChange={setPermDialogOpen}
              file={targetFile} // Pass file as 'file' prop
              type="file"
              onUpdate={() => {
                // Refresh list?
                // For now just close
              }}
            />
          )}
        </>
      )}
    </div>
  );
}
